//
import { Pedido } from '../../shared/entity/Pedido';
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import Collapsible from 'react-native-collapsible';
import colors from '../../colors';
import Title from '../Generic/Title';
import Touchable from '../Generic/Touchable';
import { useIsBigScreen } from '../../helper';
import moment from 'moment-timezone';
import { calcularTotalPedido, formatarDinheiro, calcularTotalDesconto } from '../../shared/helper';
import MiniInfo from '../Generic/MiniInfo';
import { PEDIDO_NOVO, PEDIDO_LIDO, PEDIDO_CANCELADO } from '../../shared/constants';
import ItemProdutoNoPedido from '../PedidoPage/ItemProdutoNoPedido';
import Divider from '../Generic/Divider';
import { TXT_M } from '../../constants';
import { Ionicons } from '@expo/vector-icons';

type Props = {
  pedido?: Pedido | null;

  goToPedido: (id: number) => void;
};

const ItemPedido: React.FC<Props> = (props) => {
  const { pedido, goToPedido } = props;
  const [fechado, setFechado] = useState(true);
  const [data, setData] = useState('');

  useEffect(() => {
    setData(moment(pedido.createdAt).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'));
  }, [pedido]);

  const parseStatus = () => {
    switch (pedido.status) {
      case PEDIDO_NOVO:
        return 'NÃO LIDO';
      case PEDIDO_LIDO:
        return 'CONFIRMADO';
      case PEDIDO_CANCELADO:
        return 'CANCELADO';
      default:
        return pedido.status;
    }
  };

  const getCorStatus = () => {
    switch (pedido.status) {
      case PEDIDO_NOVO:
        return colors.yellow;
      case PEDIDO_LIDO:
        return colors.green;
      case PEDIDO_CANCELADO:
        return colors.red;
      default:
        return colors.lightGrey;
    }
  };

  if (!pedido) {
    return null;
  }

  return (
    <Touchable onPress={() => setFechado(!fechado)} style={styles.container}>
      <View style={styles.content}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5 }}>
          <Text style={styles.text}>{data}</Text>
          <MiniInfo>{pedido.endereco ? 'DELIVERY' : 'BALCÃO'}</MiniInfo>
        </View>

        <Collapsible collapsed={fechado} style={{ paddingTop: 10 }}>
          {pedido.produtosNoPedido.map((produto, index) => (
            <ItemProdutoNoPedido
              produto={produto}
              index={index}
              key={produto.id + 'index' + index}
              bloquearAcoes={true}
            />
          ))}

          {pedido.endereco && (
            <View style={styles.center}>
              <Text style={styles.text}>Entrega:</Text>
              <Text style={{ color: colors.values }}>
                +R$ {formatarDinheiro(pedido.precoDelivery)}
              </Text>
            </View>
          )}

          {pedido.cupom && (
            <View style={styles.center}>
              <Text style={styles.text}>Cupom:</Text>
              <Text style={{ color: colors.red }}>
                -R$ {formatarDinheiro(calcularTotalDesconto(pedido, pedido.precoDelivery))}
              </Text>
            </View>
          )}

          <Divider style={{ marginBottom: 10, marginTop: 10 }} />
        </Collapsible>

        <View style={styles.center}>
          <Text style={styles.text}>
            TOTAL:{' '}
            <Text style={{ color: colors.values }}>R$ {formatarDinheiro(pedido.totalLiquido)}</Text>
          </Text>
          <MiniInfo backgroundColor={getCorStatus()}>{parseStatus()}</MiniInfo>
        </View>
      </View>

      <View style={{ backgroundColor: colors.lightGrey, alignItems: 'center' }}>
        {fechado ? (
          <Ionicons name="ios-arrow-down" size={20} color={'#fff'} />
        ) : (
          <Ionicons name="ios-arrow-up" size={20} color={'#fff'} />
        )}
      </View>
    </Touchable>
  );
};

const styles = StyleSheet.create({
  button: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    // backgroundColor: '#ff0',
    paddingTop: 10,
    paddingBottom: 10
  },
  container: {
    backgroundColor: '#fff',
    width: '100%',
    marginBottom: 15,
    borderWidth: 2,
    borderColor: colors.lightGrey,
    borderRadius: 7
  },
  content: {
    padding: 15
  },
  text: { fontSize: TXT_M, color: colors.primary },
  center: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }
});

export default ItemPedido;
